import { ReactComponent as AdvieskeuzeLogoRegular } from '~/assets/images/Logo.svg';
import { ReactComponent as AdvieskeuzeLogoDiap } from '~/assets/images/LogoDiap.svg';
import { cn } from '~/helpers/utils';

type HeaderLogoProps = {
  variant?: 'light' | 'dark';
  wrapLogoInH1?: boolean;
};

const HeaderLogo = ({
  variant = 'light',
  wrapLogoInH1 = false,
}: HeaderLogoProps) => {
  const logoClassName = 'w-32 h-auto md:w-40 lg:w-52';

  const logo = (
    <a href="/" className={cn('block', logoClassName)}>
      {variant === 'light' ? (
        <AdvieskeuzeLogoRegular className={logoClassName} />
      ) : (
        <AdvieskeuzeLogoDiap className={logoClassName} />
      )}
      <span className="sr-only">Advieskeuze</span>
    </a>
  );

  if (wrapLogoInH1) {
    return <h1 className="m-0 leading-none">{logo}</h1>;
  }

  return logo;
};

export default HeaderLogo;
